const styles = {
  root: {
    marginBottom: 3,
    // padding: 2,
    // backgroundColor: 'background.grey500',
  },
  container: {
    padding: 2,
    // backgroundColor: 'background.grey500',
    // padding: 1,
    // backgroundColor: 'background.grey450',
    // borderRadius: '2px',
  },
  item: {
    padding: 1,
    backgroundColor: 'background.grey450',
    borderRadius: '2px',
  },
  text: {
    '& span': {
      color: 'text.blue',
    },
  },
}
export default styles
